import type { LevelInfo } from "@whilecat/services/dto/level-info.ts";
import { getUserCourseLevels } from "@whilecat/services/user-course-service.ts";
import { LitElement, type PropertyValues, html } from "lit";
import { property } from "lit/decorators.js";
import "@whilecat/core/loaders/loading-element.ts";
import "./course-levels.ts";
import { localized } from "@lit/localize";

export class BaseCourseLevels extends LitElement {
    courseId: string;
    headerText: string;
    courseDescription: string;
    iconPath: string;

    @property({ attribute: false }) _levels: LevelInfo[] = [];
    @property({ attribute: false }) _enrolled = false;
    @property() loading = true;
    @property() loadingFailed = false;

    constructor(courseId: string, headerText: string, description: string, iconPath: string) {
        super();
        this.courseId = courseId;
        this.headerText = headerText;
        this.courseDescription = description;
        this.iconPath = iconPath;
    }

    firstUpdated(_changedProperties: PropertyValues<this>) {
        super.firstUpdated(_changedProperties);
        this.loadUserCourseLevels();
    }

    async loadUserCourseLevels() {
        const result = await getUserCourseLevels(this.courseId);
        if (result.ok) {
            this._enrolled = result.enrolled;
            this._levels = result.levels;
            this.loading = false;
        } else {
            this.loadingFailed = true;
        }
    }

    render() {
        if (this.loading) {
            return html`
                <loading-element
                class="loader"
                ?failed="${this.loadingFailed}"
                ></loading-element>`;
        }

        return html`
            <course-levels
                .courseId="${this.courseId}"
                .levels="${this._levels}"
                .enrolled="${this._enrolled}"
                courseName="${this.headerText}"
                courseDescription="${this.courseDescription}"
                iconPath="${this.iconPath}"
            ></course-levels>`;
    }
}

export const makeLevels = (uuid: string, name: string, description: string, iconPath: string) => {
    @localized()
    class _ extends BaseCourseLevels {
        constructor() {
            super(uuid, name, description, iconPath);
        }
    }

    return _;
};
